import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '410px',
  width: '100%',
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  width: '100%',
  marginBottom: '23px',

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    marginBottom: '15px',
  },
}));
